import * as React from 'react';
import { cn } from '../lib/cn.ts';

/**
 * Empty / Error state composition. Premium AI rule: never ship a "static
 * successful" surface — always design empty + error states.
 */
export function EmptyState({
  title,
  description,
  action,
  className,
}: {
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-md border border-dashed border-border-subtle px-6 py-10 text-center',
        className,
      )}
    >
      <p className="font-display text-base text-fg">{title}</p>
      {description ? (
        <p className="max-w-[42ch] text-sm text-fg-muted">{description}</p>
      ) : null}
      {action}
    </div>
  );
}

export function ErrorState({
  title = 'Something went off course.',
  description,
  retry,
  className,
}: {
  title?: string;
  description?: React.ReactNode;
  retry?: () => void;
  className?: string;
}) {
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-md border border-danger/40 bg-danger/5 px-6 py-10 text-center',
        className,
      )}
    >
      <p className="font-display text-base text-fg">{title}</p>
      {description ? (
        <p className="max-w-[42ch] text-sm text-fg-muted">{description}</p>
      ) : null}
      {retry ? (
        <button
          type="button"
          onClick={retry}
          className="text-xs font-medium uppercase tracking-[0.18em] text-accent transition-colors duration-quick hover:text-[rgb(var(--accent-strong))]"
        >
          Try again
        </button>
      ) : null}
    </div>
  );
}
